<template>
    <transition name="slide-fade" >
        <div  id="academicsHolder" >
            <div class="uk-child-width-1-1" uk-grid>
                <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
                    <div class="uk-container uk-container-small ">
                        <p class="uk-text-center uk-text-lead@l uk-text-large@l">
                            The future is yours, we are here to help. Make your future secure with us.
                        </p>
                    </div>
                </div>

                <div class="uk-padding uk-margin-remove-top">
                    <h1 class="uk-heading-line uk-text-center specHeading"><span>Become an Undergraduate Student</span></h1>
                    <div class="uk-container uk-container-small ">
                        <div class="uk-child-width-1-2@m" uk-grid>
                            <div class="uk-visible@m">
                                <img src="@/assets/grad12.jpg" alt="">

                            </div>
                            <div>
                                <p class="">
                                    <span class="uk-visible@m"></span>
                                    Northern Caribbean University’s students are in-demand and in the field.
                                    Become one of the many graduates who are “head hunted” by leading companies from
                                    various industries both locally and internationally.
                                    <br><br>
                                    The level and calibre of education we offer to our students is second to none in the
                                    Caribbean, and is renowned around the world in many countries.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>



                <div class="uk-padding uk-background-muted uk-margin-remove-top">
                    <h1 class="uk-heading-line uk-text-center specHeading">What do I need to start?</h1>
                    <div class="uk-container uk-container-small ">
                        <div class="uk-child-width-1-2@m" uk-grid>

                            <div>
                                <h3 class="uk-heading-bullet specHeading">Requirements</h3>
                                <p class="">
                                    Northern Caribbean University is a family of students, here are some ways you can join our family:
                                </p>

                                <ul class="uk-list uk-list-divider ">
                                    <li><router-link to="/undergradrequirements" class="uk-button-link">Undergraduate Requirements</router-link></li>
                                    <li><router-link to="/transferstudent" class="uk-button-link">Transfer Students</router-link></li>
                                    <li><router-link to="/intstudents" class="uk-button-link">International Students</router-link></li>
                                    <li><router-link to="/tuitionfees" class="uk-button-link">Tuition & Fees</router-link></li>
                                </ul>
                                <!--<div class="uk-align-right">
                                  <router-link ="#" class="uk-button uk-button-default">Admissions ..</router-link>
                                </div>-->
                            </div>
                            <div class="uk-visible@m">
                                <img src="@/assets/to_start.jpg" alt="">

                            </div>
                        </div>

                    </div>
                </div>

                <div class="uk-padding  uk-margin-remove-top">
                    <h1 class="uk-heading-line uk-text-center specHeading">What degree should i do?</h1>
                    <div class="uk-container uk-container-small ">
                        <div class="uk-child-width-1-2@m" uk-grid>

                            <div>
                                <h3 class="uk-heading-bullet specHeading">Get help choosing your path from experts</h3>
                                <p class="">
                                    As a Seventh-day Adventist Institution we understand that everyone is different.
                                    With this in mind, we seek to offer guidance in choosing the educational path that best suits
                                    your career choice. 

                                    <br><br>
                                    This process is done by our professionals who are trained to listen,
                                    analyze and turn even your hobby into a full-fledged profession.
                                </p>
                                <p>
                                    Come in and talk with us or use the chat to the right corner if <i class="uk-text-muted">(whichever is more convenient )</i>
                                </p>

                                <div class="uk-align-right">
                                    <router-link to="/undergradprograms" class="uk-button uk-button-default">Learn More..</router-link>
                                </div>
                            </div>
                            <div class="uk-visible@m">
                                <img src="@/assets/should1.jpg" alt="">

                            </div>
                        </div>

                    </div>
                </div>

                <!-- <div class="uk-padding uk-background-muted uk-margin-remove-top">
                   <h1 class="uk-heading-line uk-text-center specHeading">Graduates Stories</h1>
                   <div class="uk-container uk-container-small ">
                     <div class="uk-child-width-1-2@m" uk-grid>
                       <div class="uk-visible@m">
                         <img src="../../assets/graduate.jpg" alt="">

                       </div>
                       <div>
                         <h3 class="uk-heading-bullet specHeading">Get inspiration from graduates in the field.</h3>
                         <p class="">
                           Hear from our graduates who have gone on to be successful in their fields, but
                           have left behind stories to inspire and encourage. 
                           <br><br>
                           These stories are here to serve as
                           inspiration for prospective and current students.
                         </p>

                         <div class="uk-align-right">
                           <br>
                           <a href="#" class="uk-button uk-button-default">Read Stories</a>
                         </div>
                       </div>

                     </div>

                   </div>
                 </div>-->

                <!--<div class="uk-padding uk-margin-remove-top">

                  <div class="uk-container uk-container-small ">
                    <div class="uk-child-width-1-2@s uk-grid-collapse " uk-grid>

                    </div>

                  </div>
                </div>-->


            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "students",
        mounted(){
            window.scrollTo(0, 0);
        },
        metaInfo: {
            // Children can override the title.
            title: 'NCU Undergraduate Students',
            // Result: My Page Title ← My Site
            // If a child changes the title to "My Other Page Title",
            // it will become: My Other Page Title ← My Site
            //titleTemplate: '%s ← My Site',
            // Define meta tags here.
            meta: [
                {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
                {name: 'viewport', content: 'width=device-width, initial-scale=1'},
                {name: 'description', content: 'Undergraduate student engagement at Northern Caribbean University '}
            ]
        }
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h3{
            font-size: 1.1em !important;
        }
        h1{
            font-size: 1.2em !important;
        }
        p,li{
            font-size: 0.8em !important;
        }


    }
</style>
